import PauseIcon from '@mui/icons-material/Pause'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import IconButton from '@mui/material/IconButton'

const PlayControl = ({ playing, setPlaying }) => (
  <IconButton
    color="inherit"
    sx={{ padding: 0 }}
    onClick={() => {
      setPlaying(!playing)
    }}
  >
    {playing ? <PauseIcon /> : <PlayArrowIcon />}
  </IconButton>
)

export default PlayControl
